import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { empresa } from 'src/app/shared/object/empresa.model';
import { usuario } from 'src/app/shared/object/usuario.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import { ValidadoresService } from '../../../shared/validadores/validadores';

@Component({
  selector: 'app-dashboard1',
  templateUrl: './dashboard1.component.html',
  styleUrls: ['./dashboard1.component.scss'],
  providers: [SecurityService, ValidadoresService]
})

export class Dashboard1Component implements OnInit {
  public rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  public map: any = { lat: 51.678418, lng: 7.809007 };
  public chart1Type:string = 'bar';
  public chart2Type:string = 'pie';
  public chart3Type:string = 'line';
  public chart4Type:string = 'radar';
  public chart5Type:string = 'doughnut';
  public chartType = 'line';
  public chartDatasets: Array<any> = [
    {data: [50, 40, 60, 51, 56, 55, 40], label: '#1'},
    {data: [28, 80, 40, 69, 36, 37, 110], label: '#2'},
    {data: [38, 58, 30, 90, 45, 65, 30], label: '#3'}
  ];
  public chartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
  public chartColors:Array<any> = [];
  public dateOptionsSelect: any[];
  public bulkOptionsSelect: any[];
  public showOnlyOptionsSelect: any[];
  public filterOptionsSelect: any[];
  public chartOptions: any = {
    responsive: true,
    legend: {
      labels: {
        fontColor: '#5b5f62',
      }
    },
    scales: {
      yAxes: [{
        ticks: {
          fontColor: '#5b5f62',
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: '#5b5f62',
        }
      }]
    }
    
  };

  private client: GraphQLClient = null;
  usuarioLogueado = false;
  public nombre_empresa:string;
  rut_empresa: number;
  rut_usuario: number;
  flag_cambio:boolean;
  selectedUsuario: usuario;
  formulario: FormGroup;

  //wizard
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  constructor(client: GraphQLClient, 
    public authService: AuthService, 
    private accesolocalstorage: SecurityService, 
    public validadores: ValidadoresService, 
    private formBuilder: FormBuilder) {
    this.client = client;
    this.buildForm();
  }
  
  buildForm() {
    this.formulario = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
      confirmarpass: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
    });
    this.formulario.valueChanges.subscribe(field => {
      if (field.password !== field.confirmarpass) {
        this.formulario.controls["confirmarpass"].setErrors({ mismatch: true });
      } else {
        this.formulario.controls["confirmarpass"].setErrors(null);
      }
    });
  }

  ngOnInit() {
    this.usuarioLogueado= this.authService.isLoggedIn();
    this.authService.changeLoginStatus$.subscribe((loggedStatus: boolean)=>{
      this.usuarioLogueado = loggedStatus;
    });
    this.selectedUsuario = {
      rut_usuario: null,
      login: '',
      password: '',
      fecha_creacion: new Date(),
      fecha_modificacion: new Date(),
      mail: '',
      activo: true,
      nombre_completo: '',
      flag_cambioclave: true,
      max_conexiones_concurrentes: 1
    };
    this.obtenerNombreEmpresa();
    this.obtenerDatosUsuario();

    //wizard
    //firstForm
    this.firstFormGroup = new FormGroup({
      rut_user: new FormControl('', Validators.required),
      nom_user: new FormControl('', Validators.required),
      nom_ape: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      pass1: new FormControl('', Validators.required),
      pass2: new FormControl('', Validators.required)
    });

    //secondForm
    this.secondFormGroup = new FormGroup({
      rut_empr: new FormControl('', Validators.required),
      nom_empr: new FormControl('', Validators.required)
    });

  }

  //wizard
  //firstForm
  get rut_user() { return this.firstFormGroup.get('rut_user'); }
  get nom_user() { return this.firstFormGroup.get('nom_user'); }
  get nom_ape() { return this.firstFormGroup.get('nom_ape'); }
  get email() { return this.firstFormGroup.get('email'); }
  get pass1() { return this.firstFormGroup.get('pass1'); }
  get pass2() { return this.firstFormGroup.get('pass2'); }

  //secondForm
  get rut_empr() { return this.secondFormGroup.get('rut_empr'); }
  get nom_empr() { return this.secondFormGroup.get('nom_empr'); }

  obtenerNombreEmpresa() {
    let self = this; 
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa();
    var bodyx: empresa = new empresa();
    bodyx.rut= self.rut_empresa;
    this.client.query({
      query: gql`
      query($entidad: empresaInputType){
        empresa{
          obtenerSegunId(entidad:$entidad){
            respuesta{
              rut
              nombre
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      },
      fetchPolicy: 'network-only',
    }, 
    function (respuesta) {
      self.nombre_empresa = respuesta.data.empresa.obtenerSegunId.respuesta.nombre;
    });
  }

  obtenerDatosUsuario() {
    let self = this; 
    this.rut_usuario = this.rutUsuario;
    var bodyx: usuario = new usuario();
    bodyx.rut_usuario= self.rut_usuario;
    this.client.query({
      query: gql`
      query($entidad:usuarioInputType){
        usuario{
          obtenerSegunId(entidad:$entidad){
            respuesta{
              rut_usuario
              login
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
              max_conexiones_concurrentes
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      },
      fetchPolicy: 'network-only',
    }, 
    function (respuesta) {
      self.flag_cambio = respuesta.data.usuario.obtenerSegunId.respuesta.flag_cambioclave;
      self.selectedUsuario = respuesta.data.usuario.obtenerSegunId.respuesta;
    });
  }

  cambioClave() {
    let self = this; 
    this.rut_usuario = this.rutUsuario;
    var bodyx = this.selectedUsuario;
    delete bodyx["__typename"];
    bodyx.flag_cambioclave = false;
    bodyx.password =  self.formulario.controls["password"].value;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: usuarioInputType)
      {
        usuario
        {
          modificar(entidad: $entidad) {
            respuesta{
              rut_usuario
              login
              password
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave     
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        // if (respuesta.data.usuario.modificar.respuesta != undefined) {
        //   setTimeout(() => self.obtenerDatosUsuario(), 1000);
        // }
      });
  }
}
